import { jsxs as E, jsx as w } from "react/jsx-runtime";
import { I as j } from "./ic_arrowmore_fill-t069C13c.mjs";
import { createContext as ne, useContext as re, useState as A, useMemo as F, useEffect as C, useRef as T, useCallback as I, forwardRef as K, isValidElement as oe, cloneElement as ae } from "react";
import { e as H } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as S } from "./tw-cn-mXgPecoF.mjs";
import { c as z } from "./index-BpNK5r1N.mjs";
import { o as U } from "./index-CcECYkhV.mjs";
import { I as le } from "./ic_arrowless_fill-EoSHNXJu.mjs";
const _ = z(["relative w-full bg-static-white select-none"]), q = z(
  [
    "relative flex w-full min-h-32 py-4 px-16 items-center cursor-pointer !truncate",
    "border border-line-neutral-weak3 overflow-hidden rounded-8",
    "bg-static-white text-text-neutral-main placeholder:text-text-neutral-main",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "disabled:bg-fill-neutral-weak disabled:cursor-not-allowed",
    "disabled:text-interaction-neutral-disable-main disabled:hover-never:bg-fill-neutral-weak",
    "disabled:placeholder:text-interaction-neutral-disable-main disabled:hover-never:place-holder:bg-fill-neutral-weak"
  ],
  {
    variants: {
      open: {
        true: "rounded-b-none border-b-0",
        false: ""
      },
      selected: {
        true: "!font-bold text-text-neutral-main",
        false: "text-text-neutral-sub"
      },
      size: {
        small: "h-32 typography-body-12-regular pr-36",
        medium: "h-44 typography-subtitle-16-regular pr-40"
      },
      pcSize: {
        small: "pc:h-32 pc:typography-body-12-regular pc:pr-36",
        medium: "pc:h-44 pc:typography-subtitle-16-regular pc:pr-40"
      }
    }
  }
), Z = z(
  [
    "absolute right-16 top-1/2 size-16 -translate-y-1/2 pointer-events-none",
    "aria-disabled:text-interaction-neutral-disable-main"
  ],
  {
    variants: {
      open: {
        true: "rotate-180",
        false: ""
      },
      size: {
        small: "size-16",
        medium: "size-20"
      },
      pcSize: {
        small: "pc:size-16",
        medium: "pc:size-20"
      },
      disabled: {
        true: "hidden",
        false: ""
      }
    }
  }
), se = z(
  ["absolute w-full rounded-b-8 border border-line-neutral-weak3 bg-static-white", "absolute border-t-0 "],
  {
    variants: {
      size: {
        small: "top-32",
        medium: "top-44"
      },
      pcSize: {
        small: "pc:top-32",
        medium: "pc:top-44"
      }
    }
  }
), ie = z(
  ["flex py-4 px-20 items-center cursor-pointer", "hover:bg-interaction-neutral-presshover-weak1"],
  {
    variants: {
      size: {
        small: "min-h-32 typography-body-12-regular",
        medium: "min-h-44 typography-subtitle-16-regular"
      },
      pcSize: {
        small: "pc:min-h-32 pc:typography-body-12-regular",
        medium: "pc:min-h-44 pc:typography-subtitle-16-regular"
      }
    }
  }
), $ = (n) => {
  const { value: o, size: a, className: l, ...e } = n, r = H({
    property: a,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "small", pc: "medium" }
  }), s = _(), t = q({ ...r, selected: !!o }), d = Z({ ...r, disabled: e.disabled });
  return /* @__PURE__ */ E("div", { className: S("relative", s, l), children: [
    /* @__PURE__ */ w("input", { ...e, className: t, readOnly: !0, value: o }),
    /* @__PURE__ */ w(j, { "aria-disabled": e.disabled, className: d })
  ] });
};
$.displayName = "NDS.SelectboxButton";
const G = ne(null);
function M() {
  const n = re(G);
  if (n === null)
    throw new Error("useSelectContext must be used within a SelectProvider");
  return n;
}
function de({ open: n, value: o, size: a, onChangeValue: l, onChangeOpen: e, children: r }) {
  const [s, t] = A({
    value: o,
    candidateOption: null,
    options: /* @__PURE__ */ new Map()
  }), d = H({
    property: a,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "small", pc: "medium" }
  }), c = F(
    () => ({
      onChangeOpen: e,
      onChangeValue: l,
      setOption(i, f) {
        t((y) => {
          const { options: u } = y, g = new Map(u);
          return g.set(i, { value: f }), { ...y, options: g };
        });
      },
      setCandidateOption(i) {
        t((f) => ({ ...f, candidateOption: i }));
      }
    }),
    [e, l]
  ), b = F(
    () => ({ ...s, open: !!n, ...d, ...c }),
    [s, n, c]
  );
  return C(() => {
    t((i) => ({ ...i, value: o, isOpen: !1 }));
  }, [o]), C(() => {
    n || t((i) => ({
      ...i,
      options: /* @__PURE__ */ new Map(),
      candidateOption: null
    }));
  }, [n]), /* @__PURE__ */ w(G.Provider, { value: b, children: r });
}
const B = ({ value: n, className: o, isCustom: a = !1, children: l }) => {
  const e = T(null), {
    value: r,
    candidateOption: s,
    setCandidateOption: t,
    size: d,
    pcSize: c,
    setOption: b,
    onChangeValue: i,
    onChangeOpen: f
  } = M(), y = ie({ size: d, pcSize: c }), u = r === n, g = s === e.current;
  C(() => {
    const p = e.current;
    b(p, n);
  }, [n, b]);
  const N = I(() => {
    i(n), f(!1);
  }, [n, i, f]), O = I(() => {
    const p = e.current;
    t(p);
  }, [t]);
  return /* @__PURE__ */ w(
    "li",
    {
      "aria-selected": u,
      className: a ? o : S(
        y,
        { "bg-interaction-neutral-presshover-weak1 !font-bold": u },
        { "bg-interaction-neutral-presshover-weak1": g },
        o
      ),
      onClick: N,
      onMouseEnter: O,
      ref: e,
      role: "option",
      tabIndex: -1,
      children: l
    }
  );
};
B.displayName = "NDS.DropdownOption";
const J = K(({ className: n, style: o, children: a }, l) => {
  const { open: e, size: r, pcSize: s } = M(), t = se({ size: r, pcSize: s });
  return e ? /* @__PURE__ */ w("ul", { className: S(t, n), ref: l, style: o, children: a }) : null;
});
J.displayName = "NDS.DropdownOptions";
const Q = K((n, o) => {
  const { onClick: a, onKeyDown: l, ...e } = n, r = T(null), { value: s, options: t, candidateOption: d, open: c, size: b, pcSize: i, setCandidateOption: f, onChangeValue: y, onChangeOpen: u } = M(), g = q({ size: b, pcSize: i, open: c, selected: !!s }), N = Z({ size: b, pcSize: i, open: c, disabled: e.disabled }), O = I(
    (v) => {
      u(!c), a == null || a(v);
    },
    [a, u, c]
  ), p = I(
    (v) => {
      if (v.preventDefault(), t.size === 0) return;
      const D = (h) => [...t].findIndex(([x]) => x === h);
      if (c)
        switch (v.code) {
          case "ArrowUp": {
            const h = D(d);
            if (h !== -1) {
              const m = (h - 1 + t.size) % t.size, x = [...t.keys()][m];
              f(x);
            } else {
              const m = [...t.keys()][0];
              f(m);
            }
            break;
          }
          case "ArrowDown": {
            const h = D(d);
            if (h !== -1) {
              const m = (h + 1) % t.size, x = [...t.keys()][m];
              f(x);
            } else {
              const m = [...t.keys()][0];
              f(m);
            }
            break;
          }
          case "Enter": {
            if (d === null) break;
            const { value: h } = t.get(d);
            y(h), u(!1);
            break;
          }
          case "Escape":
          case "Tab": {
            u(!1);
            break;
          }
        }
      else
        switch (v.code) {
          case "Enter":
          case "ArrowDown": {
            u(!0);
            break;
          }
        }
      l == null || l(v);
    },
    [t, d, c, f, l, y, u]
  );
  return /* @__PURE__ */ E("div", { className: "relative", children: [
    /* @__PURE__ */ w(
      "input",
      {
        ...e,
        className: g,
        onClick: O,
        onFocus: () => {
          var v;
          return (v = r.current) == null ? void 0 : v.blur();
        },
        onKeyDown: p,
        readOnly: !0,
        ref: U([r, o])
      }
    ),
    /* @__PURE__ */ w(j, { "aria-disabled": e.disabled, className: N })
  ] });
});
Q.displayName = "NDS.DropdownTrigger";
const X = K(({ children: n, className: o }, a) => {
  const l = T(null), { open: e, onChangeOpen: r } = M(), s = _();
  return C(() => {
    if (!e) return;
    const t = l.current, d = (c) => {
      const b = c.target;
      t.contains(b) || r(!1);
    };
    return document.addEventListener("click", d), () => {
      document.removeEventListener("click", d);
    };
  }, [e, r]), /* @__PURE__ */ w("div", { className: S(s, o), ref: U([l, a]), children: n });
});
X.displayName = "DropdownWrapper";
const Y = (n) => {
  const {
    id: o,
    name: a,
    placeholder: l,
    defaultValue: e,
    value: r,
    options: s,
    required: t,
    disabled: d,
    size: c,
    optionZIndex: b = 10,
    customOptions: i,
    onFocus: f,
    onBlur: y,
    onChange: u,
    children: g,
    className: N,
    optionClassName: O
  } = n, p = T(null), v = T(null), [D, h] = A(!1), [m, x] = A(""), V = (k) => {
    h(k);
  }, P = () => {
    h(!1);
  };
  C(() => {
    const k = p.current, R = r || k.value || e || k.defaultValue;
    x(R);
  }, [r, e]), C(() => {
    var L;
    const k = p.current;
    (L = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set) == null || L.call(k, m || "");
    const te = new Event("change", { bubbles: !0 });
    k.dispatchEvent(te), k.focus();
  }, [m]);
  const W = () => s ? s.map(({ value: k, label: R }) => /* @__PURE__ */ w(B, { value: k, children: R }, k)) : i ? ce(i, P) : typeof g == "function" ? g({ onClose: P }) : g;
  return /* @__PURE__ */ w(
    de,
    {
      size: c,
      value: m,
      open: D,
      onChangeOpen: V,
      onChangeValue: x,
      children: /* @__PURE__ */ E(X, { className: N, ref: v, children: [
        /* @__PURE__ */ w(
          Q,
          {
            disabled: d,
            id: o,
            name: a,
            onBlur: y,
            onChange: (k) => {
              u == null || u(k);
            },
            onFocus: f,
            placeholder: l,
            readOnly: !0,
            ref: p,
            required: t
          }
        ),
        /* @__PURE__ */ w(J, { className: S("overflow-hidden", O), style: { zIndex: b }, children: W() })
      ] })
    }
  );
};
function ce(n, o) {
  return n ? n.map((a, l) => {
    if (!oe(a)) return a;
    const e = a, r = e.props.onClick;
    return ae(e, {
      onClick: (s) => {
        r == null || r(s), o();
      },
      key: e.key ?? l
    });
  }) : null;
}
Y.displayName = "NDS.Dropdown";
const ue = z(
  ["relative overflow-hidden", "border border-solid border-line-neutral-weak3", "rounded-b-8", "gap-4"],
  {
    variants: {
      isOpen: {
        true: "border-2 border-line-neutral-main border-t-0",
        false: ""
      }
    },
    defaultVariants: {
      isOpen: !1
    }
  }
), pe = z(["relative typography-subtitle-16-regular"], {
  variants: {
    isOpen: {
      true: "rounded-b-none",
      false: ""
    },
    disabled: {
      true: "!font-bold text-text-neutral-main",
      false: "text-text-neutral-sub"
    }
  }
}), be = z(
  [
    "relative flex w-full min-h-44 py-4 px-16 items-center cursor-pointer",
    "border border-line-neutral-weak3 overflow-hidden rounded-8",
    "typography-subtitle-16-regular",
    "bg-static-white text-text-neutral-main placeholder:text-text-neutral-main",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "text-left",
    "disabled:bg-fill-neutral-weak disabled:cursor-not-allowed disabled:active:bg-fill-neutral-weak disabled:active:cursor-not-allowed",
    "disabled:text-interaction-neutral-disable-main disabled:hover-never:bg-fill-neutral-weak",
    "disabled:placeholder:text-interaction-neutral-disable-main disabled:hover-never:place-holder:bg-fill-neutral-weak"
  ],
  {
    variants: {
      isAccent: {
        true: "border-2 border-line-neutral-main",
        false: ""
      },
      isOpen: {
        true: "rounded-b-none border-2 border-line-neutral-main border-b-0",
        false: "before:hidden"
      },
      disabled: {
        true: "cursor-not-allowed",
        false: ""
      },
      hasDivider: {
        true: "before:absolute before:bottom-0 before:left-0 before:h-1 before:w-full before:bg-fill-neutral-weak3",
        false: ""
      }
    },
    defaultVariants: {
      isOpen: !1
    }
  }
), fe = z(
  ["aria-disabled:text-interaction-neutral-disable-main", "ml-auto shrink-0", "size-20"],
  {
    variants: {
      isOpen: {
        true: "",
        false: "rotate-180"
      },
      disabled: {
        true: "hidden",
        false: ""
      }
    }
  }
), me = z(["mr-8 break-words"], {
  variants: {
    selected: {
      true: "text-text-neutral-main typography-subtitle-16-bold",
      false: "text-text-neutral-sub"
    },
    isAccent: {
      true: "",
      false: ""
    },
    disabled: {
      true: "cursor-not-allowed text-interaction-neutral-disable-main",
      false: ""
    },
    disabledAccent: {
      true: ["border-line-neutral-weak3 bg-fill-neutral-weak1", "text-text-neutral-sub typography-subtitle-16-bold"],
      false: ""
    }
  },
  defaultVariants: {
    //
  }
}), ee = K(
  ({
    value: n,
    isOpen: o,
    placeholder: a = "선택해 주세요",
    className: l,
    onClick: e,
    zIndex: r,
    isDisabled: s,
    isAccent: t,
    textClassName: d,
    needDisabledAccent: c,
    hasDivider: b
  }, i) => {
    const f = r ? `z-${r}` : "z-1", y = be({
      isOpen: o,
      isAccent: t,
      disabled: s,
      hasDivider: b
    }), u = me({
      selected: !!n,
      disabled: s,
      isAccent: t,
      disabledAccent: c
    }), g = fe({ isOpen: o, disabled: s });
    return /* @__PURE__ */ E(
      "button",
      {
        "aria-expanded": o,
        "aria-haspopup": "listbox",
        className: S(y, l, f),
        disabled: s,
        onClick: e,
        ref: i,
        type: "button",
        children: [
          /* @__PURE__ */ w("span", { className: S(u, d), children: n || a }),
          /* @__PURE__ */ w(le, { className: S(g) })
        ]
      }
    );
  }
);
ee.displayName = "PullDownTrigger";
const we = ({
  children: n,
  value: o,
  isOpen: a,
  defaultOpen: l = !1,
  onOpenChange: e,
  placeholder: r = "선택해 주세요",
  triggerClassName: s,
  triggerContentClassName: t,
  contentClassName: d,
  wrapperClassName: c,
  disabled: b,
  isClosable: i = !1,
  isAccent: f = !1,
  needDisabledAccent: y,
  hasDivider: u
}) => {
  const [g, N] = A(l), O = a !== void 0, p = O ? a : g, v = T(null), D = pe({ isOpen: p, disabled: b }), h = ue({ isOpen: p }), m = I(
    (x) => {
      b || !i && p || (O ? e == null || e(x) : N(x));
    },
    [p, e, b, i, O]
  );
  return C(() => {
    if (!p || !i) return;
    const x = v.current, V = (P) => {
      const W = P.target;
      x.contains(W) || m(!1);
    };
    return document.addEventListener("click", V), () => {
      document.removeEventListener("click", V);
    };
  }, [p, i, m]), /* @__PURE__ */ E("div", { className: S(D, c), ref: v, children: [
    /* @__PURE__ */ w(
      ee,
      {
        className: s,
        hasDivider: u,
        isAccent: f,
        isDisabled: b,
        isOpen: p,
        needDisabledAccent: y,
        onClick: () => {
          m(!p);
        },
        placeholder: r,
        textClassName: t,
        value: o
      }
    ),
    p ? /* @__PURE__ */ w("div", { className: S(h, d), children: n }) : null
  ] });
}, Oe = {
  Dropdown: Y,
  DropdownOption: B,
  Button: $,
  PullDown: we
};
export {
  Oe as Selectbox
};
